import { Box, useTheme } from '@mui/material';

import { CohortDataset } from './subComponents/CohortDataset';
import { CohortOwner } from './subComponents/CohortOwner';
import { CohortStatus } from './subComponents/CohortStatus';
import { CohortSubjects } from './subComponents/CohortSubjects';

export interface CohortInfoBarProps {
  cohortStatus?: string;
  datasetReleaseId?: string;
  datasetReleaseName?: string;
  ownerFirstName?: string;
  ownerLastName?: string;
  subjectCount?: number;
}

export const CohortInfoBar = ({
  cohortStatus,
  datasetReleaseId,
  datasetReleaseName,
  ownerFirstName,
  ownerLastName,
  subjectCount = -1,
}: CohortInfoBarProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', mt: `${theme.spacing(2)}` }}>
      <CohortStatus cohortStatus={cohortStatus} />
      <CohortDataset datasetReleaseId={datasetReleaseId} datasetReleaseName={datasetReleaseName} />
      <CohortOwner firstName={ownerFirstName} lastName={ownerLastName} />
      <CohortSubjects subjectCount={subjectCount} />
    </Box>
  );
};
